import Vue from 'vue'
//import VueRouter from 'vue-router'
import $ from 'jquery';
//import VueToast from 'vue-toast-notification';
import Toasted from 'vue-toasted';
import Security from '@/security.js'
import router from './router';


let Common = {
    response: "",
    //apiUrl:"http://localhost:8080/girish/data-ajax.php?__ajax_action",
    //siteUrl:"http://localhost:8080/girish/",
    siteUrl:"https://girishjewellers.com/",
    apiUrl:"https://girishjewellers.com/site/data-ajax.php?__ajax_action",
    errorContent: "",
    WAOrderText:"",
    isAppInDebugMode:false,
    traceAPIResponse:false,
    traceAPISession:false,
    backClick:null,
    ObjEvent:null,
    EventBus : new Vue(),
    pendingPostRequest:0,
    AjaxLoderRequest:0,
    AjaxLoderStatus:false,
    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    escapeRegExp(string){
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    replaceAll(str, term, replacement) {
        return str.replace(new RegExp(Common.escapeRegExp(term), 'g'), replacement);
    },
    getApiCallUrl(fun){
        Common.startRequestAjaxLoader();
        Security.SESSION_ID = sessionStorage.getItem("SESSION_ID");
        if(Common.traceAPISession)
        {
            console.log("post -> " + Security.SESSION_ID)
        }
        var url = this.apiUrl + "=" +fun;
        //var url ="http://girishjewellers.com/site/data-ajax.php?__ajax_action="+fun;
        //var url = 'http://demo.oscorpwebservice.com/girish/data-ajax.php?__ajax_action=' + fun;
        //url = url + "&APIKEY=" + Security.APIKEY + "&SESSION_ID=" + Security.SESSION_ID;
        return url;
    },
    getRequestHeader()
    {
        Security.SESSION_ID = sessionStorage.getItem("SESSION_ID");
        if(Common.traceAPISession)
        {
            console.log("post -> " + Security.SESSION_ID)
        }

        var kstr = JSON.stringify({APIKEY:Security.APIKEY,SESSION_ID:Security.SESSION_ID});
        var astr = btoa(kstr);
        
        var header = {headers: {'Content-Type': 'application/x-www-form-urlencoded','Authorization': 'Basic ' + astr }};
        //var header = {headers: {'Content-Type': 'application/json','Authorization': 'Basic ' + astr }};

        return header;

    },
    getRequestHeader_t2()
    {
            Security.SESSION_ID = sessionStorage.getItem("SESSION_ID");
            if(Common.traceAPISession)
            {
                console.log("post -> " + Security.SESSION_ID)
            }
            var kstr = "'" + Security.SESSION_ID + "':";
            var astr = btoa(kstr);

            var header = {headers: {'Content-Type': 'application/json','Token':Security.APIKEY,'Authorization': 'Basic ' + astr }};
            return header;
    },
    isMobile(){
        
        if(window.innerWidth <980)
        {
            return true;
        }
        return false;
    },
    get(url,callback_fun,Data,event="") { 

        
        //'http://localhost/gokul/data-ajax.php?__ajax_action=fetch_category'
        
        if(!$.isEmptyObject(Data))
        {
            url = url + "&" + $.param(Data);            
        }

        url = url + "&APIKEY=" + Security.APIKEY + "&SESSION_ID=" + Security.SESSION_ID 

        $.get(url, function(rdata) {

            if(rdata.response == "success")
            {
                Security.SESSION_ID = rdata.session_id;
                sessionStorage.setItem("SESSION_ID",Security.SESSION_ID);

                callback_fun(rdata.content,event);
                Common.stopRequestAjaxLoader();
                return rdata.content;
            }else
            {
                Common.stopRequestAjaxLoader();
                return "";
            }
           
        
          });

          
        
    },
    callServerFunction(fun,callback_fun,Data,event="")
    {
        //var url = 'http://localhost:8080/girish/data-ajax.php?__ajax_action=' + fun;
        
        //var url = 'http://demo.oscorpwebservice.com/girish/data-ajax.php?__ajax_action=' + fun;
        //var url = 'http://girishjewellers.com/site/data-ajax.php?__ajax_action=' + fun;
        var url = this.apiUrl + '=' + fun;
        
        
        this.post(url,callback_fun,Data,event)
        //this.get(url,callback_fun,Data,event)

        return ;
    },
    startAjaxLoader(id) {
        if(!this.AjaxLoderStatus)
        {
            var left = (window.innerWidth/2) - 120;
            var top = (window.innerHeight/2) - 120;

            eval('hideSbar();');
            $("body").prepend("<div id='PopupMask' style='position:fixed;top:40px;width:100%;height:100%;z-index:10;background-color:#fff;'><div style='width:100%;height:100%;top:"+ top +"px;left:"+ left +"px;position:absolute;'><img style='width:250px;' src='img/loader.gif' /></div></div>");
            $("#PopupMask").css('opacity', 0.5);  
            $("#"+id).data('saveZindex', $("#"+id).css( "z-index"));
            $("#"+id).data('savePosition', $("#"+id).css( "position"));
            $("#"+id).css( "z-index" , 1016 );
            $("#"+id).css( "position" , "fixed" );
        }
        this.AjaxLoderRequest++;
        this.AjaxLoderStatus = true;	
    },
    stopAjaxLoader(id) {
        if(this.AjaxLoderRequest <= 0)
        {
            if ($("#PopupMask") == null) return;
            $("#PopupMask").remove();
            $("#"+id).css( "z-index" , $("#"+id).data('saveZindex') );
            $("#"+id).css( "position" , $("#"+id).data('savePosition') );
            this.AjaxLoderStatus = false;
        }
        this.AjaxLoderRequest--;
        
    },

    startRequestAjaxLoader(id) {
        Common.pendingPostRequest++;
        console.log("this.pendingPostRequest: " + Common.pendingPostRequest);
        if(Common.pendingPostRequest>0)
        {
           if(!Common.AjaxLoderStatusR)
            {
                var left = (window.innerWidth/2) - 120;
                var top = (window.innerHeight/2) - 120;
                //eval('hideSbar();');
                $("body").prepend("<div id='PopupMaskR' style='position:fixed;top:40px;width:100%;height:100%;z-index:10;background-color:#fff;'><div style='width:100%;height:100%;top:"+ top +"px;left:"+ left +"px;position:absolute;'><img style='width:250px;' src='img/loader.gif' /></div></div>");
                $("#PopupMaskR").css('opacity', 0.5);  
                $("#"+id).data('saveZindex', $("#"+id).css( "z-index"));
                $("#"+id).data('savePosition', $("#"+id).css( "position"));
                $("#"+id).css( "z-index" , 1016 );
                $("#"+id).css( "position" , "fixed" );
            }
            Common.AjaxLoderStatusR = true;	
        }
    },
    stopRequestAjaxLoader(id) {
            if(Common.pendingPostRequest > 0)
            {
                Common.pendingPostRequest--;
            }
            console.log("this.pendingPostRequest STOP: " + Common.pendingPostRequest);
            if(Common.pendingPostRequest<=0)
            {
                if(Common.AjaxLoderStatusR)
                {
                    if ($("#PopupMaskR") == null) return;
                    $("#PopupMaskR").remove();
                    $("#"+id).css( "z-index" , $("#"+id).data('saveZindex') );
                    $("#"+id).css( "position" , $("#"+id).data('savePosition') );
                    Common.AjaxLoderStatusR = false;
                }
            }
    },    

    post(url,callback_fun,Data,event)
    {
        //Security.SESSION_ID = sessionStorage.getItem("SESSION_ID");
        
        //alert(Security.SESSION_ID + "  1");
        Common.startRequestAjaxLoader();
        Data = $.extend({"APIKEY":Security.APIKEY},Data);
        Data = $.extend({"SESSION_ID":Security.SESSION_ID},Data);
        //console.log(url);

        
        $.ajax({
          type: 'POST',
          url: url,
          data: JSON.stringify(Data),
          dataType: "json",
          error: function(err){ 
            Common.stopRequestAjaxLoader();
            if(Common.isAppInDebugMode)
            {
                Common.errorContent = err.responseText; 
                if(Common.traceAPIResponse)
                {
                    console.log(err.responseText);
                }
                router.push("/response-error");
                //window.history.pushState({errText:e}, "Response Error", "/response-error");
            }else
            {
                Common.showError("Something's went wrong!");
            }
            
        },
        xhrFields: {
            withCredentials: true
        },
        headers: this.getRequestHeader().headers
        ,
          success: function(data) { 
          
              //var obj = JSON.stringify(resultData);
              Common.stopRequestAjaxLoader();
              
              //console.log(data);
              if(data.response != "error")
              {
                    if(Common.traceAPIResponse)
                    {
                        console.log(data);
                    }
                    if(data.param != "")
                    {
                        switch(data.param.status)
                        {
                            case "done":
                                Common.showSuccess(data.param.msg);
                            break;
                            case "info":
                                Common.showInfo(data.param.msg);
                            break;
                            case "warning":
                                Common.showWarning(data.param.msg);
                            break;

                        }
                    }

                    Security.SESSION_ID = data.session_id;
                    sessionStorage.setItem("SESSION_ID",Security.SESSION_ID);
                    //console.log(data.content);
                    //alert(Security.SESSION_ID + "  2");
                    if(data.script == "")
                    {
                        callback_fun(data.content,event);    
                        
                    }
              }else
              {
                  Common.showError(data.content);
              }
                             
            }       
         });
        
    
    },
    mapResponse(data)
    {
      
        //var obj = JSON.stringify(resultData);
              Common.stopRequestAjaxLoader();
              if(Common.traceAPIResponse)
              {
                console.log(data);
              }
       
              if(typeof data !='object')
              {
                if(Common.isAppInDebugMode)
                {
                    Common.errorContent = data; 
                    //console.log(err.responseText);
                    router.push("/response-error");
                    //window.history.pushState({errText:e}, "Response Error", "/response-error");
                    return;
                }else
                {
                    Common.showError("Something's went wrong!");
                }
              }

              if(data.response != "error")
              {
                  
                    //console.log(data);
                if(data.param)
                {
                    switch(data.param.status)
                    {
                        case "done":
                            Common.showSuccess(data.param.msg);
                        break;
                        case "info":
                            Common.showInfo(data.param.msg);
                        break;
                        case "warning":
                            Common.showWarning(data.param.msg);
                        break;
                        
                    }
                }
                //alert(data.session_id);
                Security.SESSION_ID = data.session_id;
                if(Common.traceAPISession)
                {
                    console.log("Response -> " + Security.SESSION_ID)
                }
                    sessionStorage.setItem("SESSION_ID",Security.SESSION_ID);
                    //console.log(data.content);
                    //alert(Security.SESSION_ID + "  2");

                    if(data.script == "")
                    {
                        //callback_fun(data.content,event);    
                        return data.content;
                        
                    }
              }else
              {
                  Common.showError(data.content);
                  return null;
              }
              return null;
                                     
    }
    
    ,showMsg(msg,type,wait)
    { 
        
        /*Vue.use(VueToast,{
            // One of options
            position: 'top',
            duration: wait,
            dismissible:true,
            type: type, 
            message: msg
          });*/

          Vue.use(Toasted);
          $(".toasted-container").html("");
          //$(".toasted-container").attr("style","z-index:-60;");
          $(".toasted-container").attr("onclick","$('.toasted-container').html('')");

          Vue.toasted.show(msg,{type:type,duration:wait,position:'top-center',fullWidth:true,closeOnSwipe:true,singleton:true});

        
        
        //Vue.$toast.clear();
        //Vue.$toast.open();
        //setTimeout(function(){Vue.$toast.clear();},wait);
        
        //$(".toast").addClass('no-margin');
        //alert(template);

        //$("message-view").html(template);
     
    },showError(msg)
    {
        var template = '';
        template += '<span><strong style="margin-right:7px;font-size:20px;"><i class="fa fa-thumbs-down"></i></strong>';
        template += ''+ msg + '</span>';
        this.showMsg(template,'error',5000);
        //$(".toasted").addClass('alert alert-error');
        $(".toasted").attr("style","padding:20px;");

        
    },showInfo(msg)
    {
        var template = '';
        template += '<span>';
        template += '<strong style="margin-right:7px;font-size:20px;"><i class="fa fa-bell"></i></strong>'+ msg + '</span>';
        this.showMsg(template,'info',5000);
        //$(".toast").addClass('alert alert-dismissible');
        $(".toasted").attr("style","padding:20px;");
    },showWarning(msg)
    {
        var template = '';
        template += '<span>';
        template += '<strong style="margin-right:7px;font-size:20px;"><i class="fa fa-exclamation-triangle"></i></strong>'+ msg + '</span>';
        this.showMsg(template,'warning',5000);
        //$(".toasted").addClass('alert alert-warning');
        $(".toasted").attr("style","padding:20px;background-color:SALMON;");
    },showSuccess(msg)
    {
        var template = '';
        template += '<span>';
        template += '<strong style="margin-right:7px;font-size:20px;"><i class="fa fa-thumbs-up"></i></strong>'+ msg + '</span>';
       
        this.showMsg(template,'success',5000);
        //$(".toast").addClass('alert alert-dismissible');
        $(".toasted").attr("style","padding:20px;");
        
    },showValidation(msg)
    {
        var template = '';
        template += '<div style=""><H6>';
        template += '<strong style="margin-right:7px;font-size:20px;"><i class="fa fa-exclamation-triangle"></i></strong>Invalid input found!</H6>';
        template += '<ul style="">';
        
        $.each(msg, function(index, item) {
            template += '<li>' + item + '</li>';
          });

        template += '</ul><a href="javascript:$(\'.toasted\').addClass(\'hide\');"  class="close fa fa-times"></a></div>';

        this.showMsg(template,'warning',15000);
        $(".toasted").addClass('alert alert-warning');
        $(".toasted").attr("style","background-color:SALMON;");
    },
    preparValidator(validator,tag)
    {   
        $.each( validator, function( key, value ) {
           if(key == tag)
           {
                $.each( value, function( ele, atrb ) {
                    var input_html = $("#validator_" + ele + "").html();
                    var html = '<div :class="{ \'invalid\': $v.'+ tag +'.'+ ele +'.$error }">';
                    html = html + input_html + '</div>';
                    $("#validator_" + ele + "").html(html);
                    //alert( ele + ": " + atrb );
                    $.each( atrb, function( param, val ) {
                        console.log( param + ": " + val );
                    });

                });
                
           }
          });


        //console.log(JSON.stringify(validator))
        //alert(validator)
    },
    Split(str,sep){
        return str.split(sep);
    }
  }
  
export default Common